import React, { useContext } from 'react';
import { getSearchFormClickTrackingLoc } from '../../../../../../modules/utils/searchFormHelper';
import { RowProps } from './index.types';
import { StyledRowDiv } from './index.styles';
import { ariaConditionalAppend, Increment } from '@marriott/mi-ui-library-shop';
import { ContentContext } from '../../index.contexts';

const Row: React.FC<RowProps> = ({
  title,
  showCurrentValue,
  childrenFlag,
  currentValue,
  incrementHandler,
  decrementHandler,
  incrementDisable,
  decrementDisable,
  clickTrackValue,
}) => {
  const { add, remove } = useContext(ContentContext);
  return (
    <StyledRowDiv data-component-name="a-shop-Row" data-testid="shop-Row">
      <div className="row-title">
        <span {...ariaConditionalAppend('live', 'polite', childrenFlag ?? false)} className="t-font-m">
          {title}
        </span>
      </div>
      <Increment
        incrementText={`${add} ${title}`}
        decrementText={`${remove} ${title}`}
        showCurrentValue={showCurrentValue}
        currentValue={currentValue}
        incrementHandler={incrementHandler}
        decrementHandler={decrementHandler}
        incrementDisable={incrementDisable}
        decrementDisable={decrementDisable}
        clickTrackingLoc={getSearchFormClickTrackingLoc()}
        clickTrackValue={clickTrackValue}
      />
    </StyledRowDiv>
  );
};

export default Row;
